
export interface IDatabaseTaskStatus {
    nodeTag: string;
}
